export const AVAILABLE_LANGS = {
  en: 'en',
  ru: 'ru',
  uk: 'uk',
  pt: 'pt',
  es: 'es',
}

export const DEFAULT_LANG = 'default'

export const FALLBACK_LANG = 'en'

export const AVAILABLE_ARR_LANGS = ['ru', 'en', 'uk', 'pt', 'es']

export const AVAILABLE_NUVEI_LANGUAGES = ['pt,es,en']
